<div class="spinner-wrapper flex-row flex-justify-center flex-align-center">
	<div class="spinner flex-row flex-justify-center flex-align-center">
		<img src="/assets/dottnet-no-border-logo.png" alt="loading-spinner" />
	</div>
</div>
